
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/read",
      function () {
        return require("private-next-pages/read/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/read"])
      });
    }
  